import type { Api } from "api-client";
import { z } from "zod";

export const formSchema = z.object({
  email: z.email(),
});

export type FormSchema = z.infer<typeof formSchema>;

export interface AssignEmailToAthleteDialogContentProps {
  athleteId: string;
  closeModal(): void;
  onInviteSuccess?: (arg: Api.InviteAthlete.Output.Self) => void;
}
